import { booheeDetailResult, booheeRequest, booheeSearchResult, type BooheeRequest, type ChineseFoodLookup } from '../../domain/health/boohee'
import { readLimitedJson } from '../../domain/health/shortcutSync'

export class BooheeFoodLookup implements ChineseFoodLookup {
  constructor(private readonly request: (body: BooheeRequest, signal: AbortSignal) => Promise<Response>) {}
  private async call(body: BooheeRequest, signal: AbortSignal) {
    const result = await this.request(booheeRequest.parse(body), AbortSignal.any([signal, AbortSignal.timeout(15000)]))
    if (!result.ok) {
      const messages: Record<number, string> = {
        401: '请到设置检查同步读取密钥', 429: '薄荷查询额度已用完或操作过快，请稍后再试；本地食物仍可用',
        503: '薄荷查询暂不可用，请稍后再试', 502: '薄荷暂未返回可用数据，可能是额度或服务限制，请稍后再试',
      }
      throw new Error(messages[result.status] ?? '查询失败，请稍后再试')
    }
    return readLimitedJson(result.body, 64000)
  }
  async search(query: string, page: number, signal: AbortSignal) {
    return booheeSearchResult.parse(await this.call({ type: 'search', query, page }, signal))
  }
  async detail(code: string, signal: AbortSignal) {
    return booheeDetailResult.parse(await this.call({ type: 'detail', code }, signal)).food
  }
}
